<template>
  <div style="margin-bottom: 20px;">
    <div class="process">
      <div class="current-process" :style="{width: health + '%'}" />
    </div>
    <p class="current-process-desc">
      <slot name="desc">
        {{ desc }}
      </slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ActivateLowLevelStepBar',
  props: {
    health: {
      type: String,
      default: null
    },
    desc: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.process {
  width: 670px;
  height: 20px;
  margin: 0 auto;
  border-radius: 10px;
  background: #d8d8d8;

  .current-process {
    height: 20px;
    background: #ffea33;
    border-radius: 10px;
  }
}

.current-process-desc {
  margin-top: 24px;
  width: 100%;
  text-align: center;
  margin-bottom: 0;
}
</style>
